import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "orientation", "isDisabled", "align"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import "./main.css";
import { useSlotProps as $3Yfv0$useSlotProps, useStyleProps as $3Yfv0$useStyleProps, useDOMRef as $3Yfv0$useDOMRef, useResizeObserver as $3Yfv0$useResizeObserver, classNames as $3Yfv0$classNames, SlotProvider as $3Yfv0$SlotProvider } from "@react-spectrum/utils";
import { useValueEffect as $3Yfv0$useValueEffect, filterDOMProps as $3Yfv0$filterDOMProps } from "@react-aria/utils";
import { useProvider as $3Yfv0$useProvider, useProviderProps as $3Yfv0$useProviderProps, Provider as $3Yfv0$Provider } from "@react-spectrum/provider";
import $3Yfv0$react, { useCallback as $3Yfv0$useCallback, useEffect as $3Yfv0$useEffect, useRef as $3Yfv0$useRef } from "react";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $bd4bfa55854eb3bf$exports = {};
$parcel$export($bd4bfa55854eb3bf$exports, "ButtonGroup", function () {
  return $bd4bfa55854eb3bf$export$69b1032f2ecdf404;
});
var $fddc5368d2db28a6$exports = {};
$parcel$export($fddc5368d2db28a6$exports, "spectrum-ButtonGroup", function () {
  return $fddc5368d2db28a6$export$a92faf51352ac608;
}, function (v) {
  return $fddc5368d2db28a6$export$a92faf51352ac608 = v;
});
$parcel$export($fddc5368d2db28a6$exports, "spectrum-ButtonGroup-Button", function () {
  return $fddc5368d2db28a6$export$7184de2337c1927f;
}, function (v) {
  return $fddc5368d2db28a6$export$7184de2337c1927f = v;
});
$parcel$export($fddc5368d2db28a6$exports, "spectrum-ButtonGroup--alignEnd", function () {
  return $fddc5368d2db28a6$export$30e96c53d7beca11;
}, function (v) {
  return $fddc5368d2db28a6$export$30e96c53d7beca11 = v;
});
$parcel$export($fddc5368d2db28a6$exports, "spectrum-ButtonGroup--alignCenter", function () {
  return $fddc5368d2db28a6$export$252bc7c4ae05757;
}, function (v) {
  return $fddc5368d2db28a6$export$252bc7c4ae05757 = v;
});
$parcel$export($fddc5368d2db28a6$exports, "spectrum-ButtonGroup--vertical", function () {
  return $fddc5368d2db28a6$export$84d9c0e1917a4eaf;
}, function (v) {
  return $fddc5368d2db28a6$export$84d9c0e1917a4eaf = v;
});
var $fddc5368d2db28a6$export$a92faf51352ac608;
var $fddc5368d2db28a6$export$7184de2337c1927f;
var $fddc5368d2db28a6$export$30e96c53d7beca11;
var $fddc5368d2db28a6$export$252bc7c4ae05757;
var $fddc5368d2db28a6$export$84d9c0e1917a4eaf;
$fddc5368d2db28a6$export$a92faf51352ac608 = "spectrum-ButtonGroup_b10c2f";
$fddc5368d2db28a6$export$7184de2337c1927f = "spectrum-ButtonGroup-Button_b10c2f";
$fddc5368d2db28a6$export$30e96c53d7beca11 = "spectrum-ButtonGroup--alignEnd_b10c2f";
$fddc5368d2db28a6$export$252bc7c4ae05757 = "spectrum-ButtonGroup--alignCenter_b10c2f";
$fddc5368d2db28a6$export$84d9c0e1917a4eaf = "spectrum-ButtonGroup--vertical_b10c2f";

function $bd4bfa55854eb3bf$var$ButtonGroup(props, ref) {
  var _$3Yfv0$useProvider = $3Yfv0$useProvider(),
      scale = _$3Yfv0$useProvider.scale;

  props = $3Yfv0$useProviderProps(props);
  props = $3Yfv0$useSlotProps(props, 'buttonGroup');

  var _props = props,
      children = _props.children,
      _props$orientation = _props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      isDisabled = _props.isDisabled,
      _props$align = _props.align,
      align = _props$align === void 0 ? 'start' : _props$align,
      otherProps = _objectWithoutProperties(_props, _excluded);

  var _$3Yfv0$useStyleProps = $3Yfv0$useStyleProps(otherProps),
      styleProps = _$3Yfv0$useStyleProps.styleProps;

  var domRef = $3Yfv0$useDOMRef(ref);

  var _$3Yfv0$useValueEffec = $3Yfv0$useValueEffect(false),
      _$3Yfv0$useValueEffec2 = _slicedToArray(_$3Yfv0$useValueEffec, 2),
      hasOverflow = _$3Yfv0$useValueEffec2[0],
      setHasOverflow = _$3Yfv0$useValueEffec2[1];

  var checkForOverflow = $3Yfv0$useCallback(function () {
    var computeHasOverflow = function computeHasOverflow() {
      if (domRef.current && orientation === 'horizontal') {
        var buttonGroupChildren = Array.from(domRef.current.children);
        var maxX = domRef.current.offsetWidth + 1; // + 1 to account for rounding errors
        // If any buttons have negative X positions (align="end") or extend beyond
        // the width of the button group (align="start"), then switch to vertical.

        if (buttonGroupChildren.some(function (child) {
          return child.offsetLeft < 0 || child.offsetLeft + child.offsetWidth > maxX;
        })) return true;
        return false;
      }
    };

    if (orientation === 'horizontal') setHasOverflow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return false;

            case 2:
              _context.next = 4;
              return computeHasOverflow();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [domRef, orientation, scale, setHasOverflow, children]); // There are two main reasons we need to remeasure:
  // 1. Internal changes: Check for initial overflow or when orientation/scale/children change (from checkForOverflow dep array)

  $3Yfv0$useEffect(function () {
    checkForOverflow();
  }, [checkForOverflow]); // 2. External changes: buttongroup won't change size due to any parents changing size, so listen to its container for size changes to figure out if we should remeasure

  var parent = $3Yfv0$useRef();
  $3Yfv0$useEffect(function () {
    parent.current = domRef.current.parentElement;
  }, [domRef.current]);
  $3Yfv0$useResizeObserver({
    ref: parent,
    onResize: checkForOverflow
  });
  return /*#__PURE__*/$3Yfv0$react.createElement("div", _objectSpread(_objectSpread(_objectSpread({}, $3Yfv0$filterDOMProps(otherProps)), styleProps), {}, {
    ref: domRef,
    className: $3Yfv0$classNames( /*@__PURE__*/$parcel$interopDefault($fddc5368d2db28a6$exports), 'spectrum-ButtonGroup', {
      'spectrum-ButtonGroup--vertical': orientation === 'vertical' || hasOverflow,
      'spectrum-ButtonGroup--alignEnd': align === 'end',
      'spectrum-ButtonGroup--alignCenter': align === 'center'
    }, styleProps.className)
  }), /*#__PURE__*/$3Yfv0$react.createElement($3Yfv0$SlotProvider, {
    slots: {
      button: {
        UNSAFE_className: $3Yfv0$classNames( /*@__PURE__*/$parcel$interopDefault($fddc5368d2db28a6$exports), 'spectrum-ButtonGroup-Button')
      }
    }
  }, /*#__PURE__*/$3Yfv0$react.createElement($3Yfv0$Provider, {
    isDisabled: isDisabled
  }, children)));
}
/**
 * ButtonGroup handles overflow for a grouping of buttons whose actions are related to each other.
 */


var $bd4bfa55854eb3bf$export$69b1032f2ecdf404 = /*#__PURE__*/$3Yfv0$react.forwardRef($bd4bfa55854eb3bf$var$ButtonGroup);
export { $bd4bfa55854eb3bf$export$69b1032f2ecdf404 as ButtonGroup };